<template>
    <!-- Form for editing details -->
    <div class="d-flex flex-column gap-3">
        <form @submit.prevent="postOption">
            <!-- Option -->
            <Field
                class="mt-0"
                :label="capitalizedOptionType"
                v-model="formData.name"
                type="text"
                :required="true"
            />

            <AddressField
                v-if="endpoint == 'company-site'"
                :required="true"
                v-model="formData"
            />

            <Field
                v-if="endpoint == 'company-site'"
                label="Phone"
                v-model="formData.phone"
                type="tel"
                :params="{ placeholder: '0 (000) 000-0000' }"
            />

            <Field
                v-if="endpoint == 'company-site'"
                label="IPAC Lead"
                v-model="formData.ipac_lead_id"
                type="select"
                :params="{
                    options: this.$employeesStore.getEmployeeOptions(),
                    placeholder: 'Select an IPAC lead',
                    searchable: true,
                }"
            />

            <Field
                v-if="endpoint == 'company-site'"
                label="Booking Contact"
                v-model="formData.booking_contact_id"
                type="select"
                :params="{
                    options: this.$employeesStore.getEmployeeOptions(),
                    placeholder: 'Select a user',
                    searchable: true,
                }"
            />

            <!-- Save Button -->
            <div
                style="
                    padding-top: var(--space-6);
                    border-top: 1px solid var(--neutral-600);
                "
            >
                <button type="submit" class="btn btn-secondary w-100">
                    Submit
                </button>
            </div>
        </form>
        <button
            v-if="includeAllOptionsButton"
            class="btn btn-primary"
            @click="this.$emit('allOptions')"
            style="width: fit-content"
        >
            <i class="fi fi-chevron-left"></i> All {{ capitalizedOptionType }}s
        </button>
    </div>
</template>

<script>
import Field from '../Field.vue';
import AddressField from '../fields/AddressField.vue';

export default {
    name: 'OptionForm',
    components: {
        Field,
        AddressField,
    },
    props: {
        option: {
            type: Object,
            default: () => ({}),
        },
        optionTitle: {
            type: String,
            required: true,
        },
        endpoint: {
            type: String,
            required: true,
        },
        newEntry: {
            type: Boolean,
            default: false,
        },
        includeAllOptionsButton: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            formData: {},
        };
    },
    emits: ['submit', 'allOptions'],
    computed: {
        capitalizedOptionType() {
            return (
                this.optionTitle.charAt(0).toUpperCase() +
                this.optionTitle.slice(1)
            );
        },
    },
    methods: {
        resetForm() {
            this.formData = {
                id: this.option?.id || '',
                name: this.option?.name || '',
                address: this.option?.address || '',
                city: this.option?.city || '',
                province: this.option?.province || '',
                country: this.option?.country || '',
                phone: this.option?.phone || '',
                ipac_lead_id: this.option?.ipac_lead_id || null,
                booking_contact_id: this.option?.booking_contact_id || null,
            };
        },
        postOption() {
            const action = this.newEntry ? 'create' : 'update';
            const url = `${this.endpoint}/${action}`;

            let formData = { ...this.formData };

            if (action == 'create') {
                const { id, ...rest } = formData;
                formData = rest;
            }

            this.$postData(url, formData).then((response) => {
                if (response?.success) {
                    this.$emit('submit', response.data);
                    if (this.newEntry) {
                        this.$alertStore.pushSuccess(
                            `${this.capitalizedOptionType} created successfully.`
                        );
                    }
                } else {
                    this.$alertStore.pushError(response?.message);
                }
            });
        },
    },
    mounted() {
        this.resetForm();
    },
};
</script>

<style scoped>
.form-group {
    margin: 0.85rem 0;
}
</style>
